module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/created-03c2f805.svg";